export default [
  { text: "Autism Spectrum Disorder", value: 1 },
  { text: "Hearing Impairment", value: 2 },
  { text: "Mental Health Condition", value: 3 },
  { text: "Physical Disability", value: 4 },
  { text: "Progressive Chronic Condition", value: 5 },
  { text: "Vision Impairment", value: 6 },
]
